/* LA Flight School :: sales elements :: Sporty Discovery Flight element L11 (full, mini, try). Ported from the approved designs. Vanilla JS, no CDN. */
(function(){
function money(n){return '$'+String(n).replace(/\B(?=(\d{3})+(?!\d))/g,',')}
function init(root){if(root.__spc)return;root.__spc=1;
 var it=[].slice.call(root.querySelectorAll('.spc-len button')),book=root.querySelector('[data-ubook]'),gift=root.querySelector('[data-spc-gift]'),pe=root.querySelector('[data-spc-p]'),me=root.querySelector('[data-spc-m]');
 function set(b){var m=b.getAttribute('data-m');it.forEach(function(x){var on=x===b;x.setAttribute('aria-checked',String(on));x.tabIndex=on?0:-1});
  if(pe)pe.textContent=money(b.getAttribute('data-p'));if(me)me.textContent=m;if(book)book.setAttribute('data-m',m);
}
 it.forEach(function(b,n){b.addEventListener('click',function(){set(b)});b.addEventListener('keydown',function(ev){var d={ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1}[ev.key];if(d){ev.preventDefault();var x=it[(n+d+it.length)%it.length];set(x);x.focus()}})});
}
function all(){document.querySelectorAll('.spc').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
document.addEventListener('shopify:section:load',all);
})();
